import { makeCommsPage } from './commsPage'
import { CommsLocBatchesView } from '../components/views/commsLocBatchesView'

export default makeCommsPage({
    title: 'LOC batches',
    intro: 'Import a spreadsheet of claims, render each letter of claim, approve the batch and send. Failed or bounced emails can be retried, edited or cancelled per row.',
    probeUrl: 'comms/loc-batches/list',
    View: CommsLocBatchesView,
    className: 'commsLocBatches',
})
